import {
  Button,
  Card,
  InputField,
  Label,
  Select,
  SelectItem,
} from '@energybox/react-ui-library/dist/components';
import { User } from '@energybox/react-ui-library/dist/types';
import { global } from '@energybox/react-ui-library/dist/utils';

import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { getUser, getUserByEmail } from '../../actions/users';
import { ApplicationState } from '../../reducers';
import { UsersById } from '../../reducers/users';
import { Routes } from '../../routes';
import { fullName } from '../../util';
import { accessDeniedError } from '../../utils/ApiError/accessDeniedError';
import { determineUserIsEBGlobalAdmin } from '../../utils/user';
import styles from './ShowFindUserPage.module.css';

type SearchBy = 'id' | 'email';

const SEARCH_BY_TITLE: Record<SearchBy, string> = {
  id: 'ID',
  email: 'Email',
};

interface Props {
  getUser: typeof getUser;
  getUserByEmail: typeof getUserByEmail;
  usersById: UsersById;
  userApiError: Record<string, unknown>;
  showPage: boolean;
}

interface State {
  searchBy: SearchBy;
  searchValue: string;
  searchedValue: string;
  searchedBy: SearchBy;
  hasSearched: boolean;
}

class ShowFindUserPage extends React.Component<
  Props & RouteComponentProps,
  State
> {
  constructor(props: Props & RouteComponentProps) {
    super(props);
    this.state = {
      searchBy: 'email',
      searchValue: '',
      searchedValue: '',
      searchedBy: 'email',
      hasSearched: false,
    };
  }

  onSearchByChange = (searchBy: SearchBy) => this.setState({ searchBy });
  onSearchValueChange = e => this.setState({ searchValue: e.target.value });

  onSearch = () => {
    const { searchBy, searchValue } = this.state;
    const value = searchValue.trim();
    if (!value) return;

    if (searchBy === 'id') {
      this.props.getUser(value);
    } else {
      this.props.getUserByEmail(value);
    }
    this.setState({
      searchedValue: value,
      searchedBy: searchBy,
      hasSearched: true,
    });
  };

  renderUserResult = (user?: User) => {
    return (
      <>
        <div>
          {!!user && (
            <Link target='_blank' to={`${Routes.USERS}/${user.id}`}>
              {user.id}
            </Link>
          )}
        </div>
        <div>{user?.email || ''}</div>
        <div>{user ? fullName(user) : ''}</div>
        <div>
          {user ? user.organizationUnitTitle || global.NOT_AVAILABLE : ''}
        </div>
      </>
    );
  };

  render() {
    const { usersById, userApiError, showPage } = this.props;
    const { searchBy, searchValue, searchedValue, searchedBy } = this.state;

    const foundUser =
      searchedBy === 'id'
        ? usersById[searchedValue]
        : Object.values(usersById).find(
            user => user.email?.toLowerCase() === searchedValue.toLowerCase()
          );
    const hasApiError = userApiError && Object.keys(userApiError).length > 0;

    return showPage ? (
      <Card className={styles.root}>
        <div className={styles.cardContent}>
          <span>
            <Label>Search By</Label>
          </span>
          <span>
            <Label>Input</Label>
          </span>
          <span>
            <Label>ID</Label>
          </span>
          <span>
            <Label>Email</Label>
          </span>
          <span>
            <Label>Name</Label>
          </span>
          <span>
            <Label>Organization</Label>
          </span>
          <span></span>
        </div>
        <div className={styles.cardContent}>
          <span>
            <Select variant='select' title={SEARCH_BY_TITLE[searchBy]}>
              {(Object.keys(SEARCH_BY_TITLE) as SearchBy[]).map(key => (
                <SelectItem
                  key={key}
                  isSelected={key === searchBy}
                  onSelect={() => this.onSearchByChange(key)}
                >
                  {SEARCH_BY_TITLE[key]}
                </SelectItem>
              ))}
            </Select>
          </span>
          <span className={styles.inputField}>
            <InputField
              name='searchValue'
              onChange={this.onSearchValueChange}
              value={searchValue}
            />
          </span>
          {this.renderUserResult(foundUser)}
          <div>
            <Button onClick={this.onSearch}>Find User</Button>
          </div>
          {this.state.hasSearched && !foundUser && hasApiError && (
            <div className={styles.noEntryText}>No entry found.</div>
          )}
        </div>
      </Card>
    ) : (
      accessDeniedError(null, true)
    );
  }
}

const mapStateToProps = ({ users, app }: ApplicationState) => ({
  usersById: users.usersById,
  userApiError: users.userApiError,
  showPage: determineUserIsEBGlobalAdmin(app.currentUser),
});

const mapDispatchToProps = {
  getUser,
  getUserByEmail,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShowFindUserPage)
);
